var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('DebugVue',{staticClass:"screen"}),_c('FilterBar',{staticClass:"screen"}),_c('v-content',[_c('router-view')],1),_c('AppFooterVue',{staticClass:"screen"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }